import React, { Component } from "react";
import axios from "axios";
import api from "../../common/api";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import ConfirmDialog from "../../common/ConfirmDialog";
import { Container, Row, Col } from "shards-react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import NumberFormat from "react-number-format";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import RemoveIcon from "@material-ui/icons/Remove";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import Button from "@material-ui/core/Button";
import { Tooltip } from "chart.js";
import ArrowDownwardIcon from "@material-ui/icons/KeyboardArrowDown";

const chargeValueTypes = [
  { value: 0, name: "Lista de precios" },
  { value: 1, name: "Monto Fijo" },
  { value: 2, name: "Porcentaje" },
  { value: 3, name: "Definido p/Cargo" }
];
const prorationTypes = [
  { value: 0, name: "Sin Prorrateo" },
  { value: 2, name: "Por vehiculo-Contrato" }
];
const originTypes = [
  {
    name: "Cargos adicionales",
    value: 4,
    methodTypes: ["Por Monto Facturado", "Monto Global", "Por vehículo"]
  },
  {
    name: "Cuenta y Orden",
    value: 2,
    methodTypes: ["Por Tarea", "Por vehiculo"]
  },
  {
    name: "Gestion de Flota (Adicionales/Se Refactura)",
    value: 1,
    methodTypes: ["Por Tarea"]
  },
  {
    name: "Liquidación de Gastos",
    value: 5,
    methodTypes: ["Por Tarea"]
  }
];

const paymentDeadlines = [
  { value: 1, label: "Inmediato" },
  { value: 13, label: "30 días" },
  { value: 3, label: "7 días" },
  { value: 8, label: "15 días" },
  { value: 16, label: "60 días" }
];

const cutoffFrequencies = [
  { value: 0, label: "Diario" },
  { value: 7, label: "Semanal" },
  { value: 15, label: "Quincenal" },
  { value: 30, label: "Mensual" }
];

const fullMethodTypes = originTypes.reduce((acc, curr) => {
  curr.methodTypes.forEach(method => {
    if (!acc.includes(method)) {
      acc.push(method);
    }
  });
  return acc;
}, []);

const useStyles = theme => ({
  select: {
    marginRight: "16px",
    marginTop: "16px"
  },
  typography: {
    fontSize: "0.75rem"
  }
});

class Service extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      service: {
        id: "",
        contract_id: "",
        name: "",
        description: "",
        charges: [{}],
        tasks: [{ task_id: "" }],
        work_order_types: [{ work_order_type_id: "", budget_required: 0 }]
      },
      work_order_types_to_delete: [],
      snackbar: { open: false },
      charges: [],
      tasks: { task: {}, loading: false, options: [] },
      task_states: [
        { task_state_id: 1, task_state_name: "Fee incluido" },
        { task_state_id: 2, task_state_name: "No incluido" },
        { task_state_id: 3, task_state_name: "No se hará" }
      ],
      work_order_types: [],
      tasks_to_delete: [],
      budget_required_options: [
        { id: 1, value: "Si" },
        { id: 0, value: "No" }
      ],
      loading: true,
      disabled: false,
      action: "edit",
      showWorkOrderList: false,
      dialog: {
        open: false,
        message: "",
        title: "",
        errors: { errors: { errors: [] } }
      },
      delete_dialog: {
        open: false,
        message: "",
        title: "",
        errors: { errors: { errors: [] } }
      }
    };
  }

  async componentDidMount() {
    var params = this.getParams();
    if (params.contract_id !== undefined) {
      await this.getCharges();
      await this.getTasks();
      await this.getWorkOrderTypes();
      await this.getParams();
      await this.getServiceByContract(params.contract_id);
      await this.getContract(params.contract_id);
    }
    this.setState({ loading: false, contract_id: params.contract_id });
  }

  getParams() {
    return this.props.match.params;
  }

  async getServiceByContract(contract_id) {
    const token = localStorage.getItem("userToken");

    return await axios
      .get(api.service().get(contract_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ action: "view" });
        var service = this.state.service;
        service.id = res.data.id;
        service.tasks = res.data.tasks;
        service.charges = res.data.charges;
        service.work_order_types = res.data.work_order_types;
        if (service.charges.length === 0) {
          service.charges.push({});
        }
        service.charges.map((charge) => {
          charge.all_fleet = 1;
          if (!charge.vehicles){
            charge.all_fleet = 1;
          }
          if (charge.vehicles && charge.vehicles.length === 0) {
            charge.all_fleet = 1; 
          } else {
            charge.all_fleet = 0;
          }
        })
        if (service.tasks.length === 0) {
          service.tasks.push({ task_id: "" });
        }
        if (service.work_order_types.length === 0) {
          service.work_order_types.push({
            work_order_type_id: "",
            budget_required: 0,
            work_order_state_id: ""
          });
        }
        service.name = res.data.name;
        service.description = res.data.description;
        this.setState({ service: service });
        return res.data;
      })
      .catch(err => {
        this.setState({ action: "new" });
      });
  }

  getContract(contract_id) {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.contract().get(contract_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ vehicles: res.data[0].vehicles });
        this.getClient(res.data[0].contact_id);
      })
      .catch(err => {
        console.log(err);
      });
  }

  getClient(contact_id) {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.contacts().get(contact_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (res.data && res.data && res.data.client)
          this.setState({ client_id: res.data.client.id });
      })
      .catch(err => {
        console.log(err);
      });
  }

  getWorkOrderTypes() {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.dropdowns().ot(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ work_order_types: res.data.work_order_types });
      })
      .catch(err => {
        console.log(err);
      });
  }

  getCharges() {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.charges, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        this.setState({ charges: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  }

  getTasks = () => {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.tasks, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        res.data = Object.values(res.data);
        this.setState({ tasks: res.data });
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  };

  toogleWorkOrderList = idx => {
    this.setState({ showWorkOrderList: !this.state.showWorkOrderList });
  };
  handleToogleCharge = idx => {
    let service = this.state.service;
    service.charges[idx].open = !service.charges[idx].open;
    this.setState({ service: service });
  };

  handleChange = e => {
    var service = this.state.service;
    if (e.target.name === "name" || e.target.name === "description") {
      service[e.target.name] = e.target.value;
    } else {
      var element = e.target.name.split(".");
      var key = element[0];
      var id = element[1];
      if (
        [
          "task_id",
          "task_state_id",
          "description",
          "contract_description"
        ].includes(key)
      ) {
        service.tasks[id][key] = e.target.value;
      } else if (
        [
          "work_order_type_id",
          "work_order_state_id",
          "budget_required",
          "work_order_description",
          "max_total_price",
          "validate_max_total_price"
        ].includes(key)
      ) {
        if (key === "work_order_description") {
          key = "description";
        }
        if (key === "max_total_price") {
          e.target.value = e.target.value.replace("$", "");
        }
        service.work_order_types[id][key] = e.target.value;
      } else {
        service.charges[id][key] = e.target.value;
      }
    }
    this.setState({ service: service });
  };

  setDropdownTask = (idx, e) => {
    var res = idx.split("-");
    const varName = res[0];
    const id = res[1];

    let service = this.state.service;

    service.tasks[id]["task_id"] = e.value;
    service.tasks[id]["taskLabel"] = e.label;
    service.tasks.push({ task_id: "" });
    this.setState({ service: service });
  };

  handleEdit = () => {
    this.setState({ action: "edit" });
    this.setState({ disabled: false });
  };

  handleView = () => {
    this.setState({ action: "view" });
    this.setState({ disabled: true });
  };

  addNewTask = e => {
    let service = this.state.service;
    service.tasks.push({ task_id: "", unit_id: "", taskLabel: "" });
    this.setState({ service: service });
  };

  removeTask = idx => {
    var task = this.state.service.tasks[idx];
    var tasks_to_delete = this.state.tasks_to_delete;
    tasks_to_delete.push(task);
    this.setState(prevState => ({
      service: {
        ...prevState.service,
        tasks: [...prevState.service.tasks.filter((s, sidx) => idx !== sidx)]
      }
    }));
    this.setState({ tasks_to_delete: tasks_to_delete });
  };

  addNewWorkOrderType = e => {
    let service = this.state.service;
    service.work_order_types.push({ work_order_type_id: "" });
    this.setState({ service: service });
  };

  removeWorkOrderType = idx => {
    var work_order_type = this.state.service.work_order_types[idx];
    var work_order_types_to_delete = this.state.work_order_types_to_delete;
    work_order_types_to_delete.push(work_order_type);
    this.setState(prevState => ({
      service: {
        ...prevState.service,
        work_order_types: [
          ...prevState.service.work_order_types.filter(
            (s, sidx) => idx !== sidx
          )
        ]
      }
    }));
    this.setState({ work_order_types_to_delete: work_order_types_to_delete });
  };

  addNewCharge = e => {
    let service = this.state.service;
    service.charges.push({ payment_deadline: 30, cutoff_frequency: 30 });
    this.setState({ service: service });
  };

  removeCharge = (e, idx, confirmed) => {
    if (confirmed === true) {
      this.handleDeleteCharge();
    } else {
      this.handleRemoveCharge(e, idx);
    }
  };

  handleRemoveCharge = (e, idx) => {
    e.preventDefault();
    var delete_dialog = this.state.delete_dialog;
    var id = 0;
    delete_dialog.title = "Servicios contratados";
    delete_dialog.success = 0;
    delete_dialog.message = "Esta seguro de eliminar el cargo?";
    delete_dialog.open = true;
    id = this.state.service.charges[idx].id;
    this.setState({ delete_dialog: delete_dialog, delete_id: id });
  };

  handleDeleteCharge = async () => {
    var id = this.state.delete_id;
    var dialog = this.state.delete_dialog;
    var service = this.state.service;
    let self = this;
    const token = localStorage.getItem("userToken");
    await axios
      .delete(api.service().delete_charge(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        dialog.title = "Servicios contratados";
        dialog.success = 1;
        dialog.open = true;
        dialog.message = "Cargo eliminado con éxito!";
        self.setState(prevState => ({
          service: {
            ...prevState.service,
            charges: [
              ...prevState.service.charges.filter((s, sidx) => s.id !== id)
            ]
          }
        }));
        self.setState({ service: service });
      })
      .catch(function(error) {
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = "Ha ocurrido un error. Contacte a su administrador";
          }
        } else {
          error_message = "Ha ocurrido un error. Contacte a su administrador";
        }

        dialog.title = "Servicios contratados";
        dialog.success = 1;
        dialog.open = true;
        dialog.message =
          "Ha ocurrido al eliminar el cargo. Contacte a su administrador!";
        self.setState({ dialog: dialog });
        console.log(error);
      });
    this.setState({ dialog: dialog });
  };

  handleSubmit = e => {
    e.preventDefault();

    var formData = new FormData();
    formData.set("service[contract_id]", this.state.contract_id);
    formData.set("service[name]", this.state.service.name);
    formData.set("service[description]", this.state.service.description);
    var i = 0;
    this.state.service.tasks.map((val, idx) => {
      if (val.task_id || val.task) {
        if (this.state.action === "edit" && val.id != null) {
          formData.set("service[tasks][" + i + "][id]", val.id);
          formData.set("service[tasks][" + i + "][task_id]", val.task.id);
          formData.set(
            "service[tasks][" + i + "][task_state_id]",
            val.state.id
          );
        } else {
          formData.set("service[tasks][" + i + "][task_id]", val.task_id);
          formData.set(
            "service[tasks][" + i + "][task_state_id]",
            val.task_state_id
          );
        }
        formData.set("service[tasks][" + i + "][unit_id]", 1);
        formData.set("service[tasks][" + i + "][value]", 1);
        formData.set(
          "service[tasks][" + i + "][contract_description]",
          val.contract_description ? val.contract_description : ""
        );
        formData.set(
          "service[tasks][" + i + "][description]",
          val.description ? val.description : ""
        );
        i++;
      }
    });

    this.state.service.charges.map((val, idx) => {
      formData.set(
        "service[charges][" + idx + "][value]",
        val.value ? val.value : 0
      );
      formData.set(
        "service[charges][" + idx + "][description]",
        val.description ? val.description : ""
      );
      formData.set(
        "service[charges][" + idx + "][charge_id]",
        val.charge_id ? val.charge_id : ""
      );
      // add the fields of each charge, proratation, start and end date, purchase order, value, cutoff, frquency cut,
      formData.set(
        "service[charges][" + idx + "][proration]",
        val.proration ? val.proration : ""
      );
      formData.set(
        "service[charges][" + idx + "][start_date]",
        val.start_date ? val.start_date : ""
      );
      formData.set(
        "service[charges][" + idx + "][end_date]",
        val.end_date ? val.end_date : ""
      );
      formData.set(
        "service[charges][" + idx + "][purchase_order]",
        val.purchase_order ? val.purchase_order : ""
      );
      formData.set(
        "service[charges][" + idx + "][payment_deadline]",
        val.payment_deadline ? val.payment_deadline : ""
      );
      formData.set(
        "service[charges][" + idx + "][cutoff_frequency]",
        val.cutoff_frequency ? val.cutoff_frequency : ""
      );
      formData.set(
        "service[charges][" + idx + "][default_vehicle_id]",
        val.default_vehicle_id ? val.default_vehicle_id : ""
      );
      formData.set(
        "service[charges][" + idx + "][value_type]",
        val.value_type ? val.value_type : ""
      );
      formData.set(
        "service[charges][" + idx + "][source_type]",
        val.source_type ? val.source_type : ""
      );

      if (val.id) {
        if (this.state.action === "edit" && val.id != null) {
          formData.set("service[charges][" + idx + "][id]", val.id);
        }
      }
    });
    /*this.state.tasks_to_delete.map((val, idx) => {
      if (val.task_id || val.task.id) {
        if (this.state.action === "edit" && val.id != null) {
          formData.set("service[tasks][" + i + "][id]", val.id);
          formData.set("service[tasks][" + i + "][task_id]", val.task.id);
          formData.set(
            "service[tasks][" + i + "][task_state_id]",
            val.state.id
          );
        } else {
          formData.set("service[tasks][" + i + "][task_id]", val.task_id);
          formData.set(
            "service[tasks][" + i + "][task_state_id]",
            val.task_state_id
          );
        }
        formData.set("service[tasks][" + i + "][unit_id]", 1);
        formData.set("service[tasks][" + i + "][value]", 1);
        formData.set(
          "service[tasks][" + i + "][contract_description]",
          val.contract_description ? val.contract_description : ""
        );
        formData.set(
          "service[tasks][" + i + "][description]",
          val.description ? val.description : ""
        );
        formData.set("service[tasks][" + i + "][deleted_at]", Date.now());
        i++;
      }
    });
    */
    this.state.service.work_order_types.map((val, idx) => {
      if (val.id) {
        if (this.state.action === "edit" && val.id != null) {
          formData.set("service[work_order_types][" + i + "][id]", val.id);
          formData.set(
            "service[work_order_types][" + i + "][work_order_type_id]",
            val.work_order_type.id
          );
        } else {
          formData.set(
            "service[work_order_types][" + i + "][work_order_type_id]",
            val.work_order_type_id
          );
        }
        //				formData.set('service[work_order_types]['+i+'][work_order_type_id]', val.work_order_type_id)
        formData.set(
          "service[work_order_types][" + i + "][work_order_state_id]",
          val.work_order_state_id ? val.work_order_state_id : 1
        );
        formData.set("service[work_order_types][" + i + "][value]", "");
        formData.set(
          "service[work_order_types][" + i + "][description]",
          val.description ? val.description : ""
        );
        formData.set(
          "service[work_order_types][" + i + "][budget_required]",
          val.budget_required
        );
        formData.set(
          "service[work_order_types][" + i + "][max_total_price]",
          val.max_total_price ? val.max_total_price : ""
        );
        formData.set(
          "service[work_order_types][" + i + "][validate_max_total_price]",
          val.validate_max_total_price ? val.validate_max_total_price : false
        );
        i++;
      }
    });
    this.state.work_order_types_to_delete.map((val, idx) => {
      if (this.state.action === "edit" && val.id != null) {
        formData.set("service[work_order_types][" + i + "][id]", val.id);
        formData.set(
          "service[work_order_types][" + i + "][work_order_type_id]",
          val.work_order_type.id
        );
      } else {
        formData.set(
          "service[work_order_types][" + i + "][work_order_type_id]",
          val.work_order_type_id
        );
      }
      formData.set("service[work_order_types][" + i + "][value]", "");
      formData.set(
        "service[work_order_types][" + i + "][work_order_state_id]",
        val.work_order_state_id ? val.work_order_state_id : 1
      );
      formData.set(
        "service[work_order_types][" + i + "][deleted_at]",
        Date.now()
      );
      formData.set(
        "service[work_order_types][" + i + "][description]",
        val.description ? val.description : ""
      );
      i++;
    });

    i = 0;
    /*		this.state.service.charges.map((val, idx) => {
			if (val.charge_type_id){
				if (this.state.action === 'edit' && val.id != null){
					formData.set('service[charges]['+i+'][id]', val.id)
				}
				
				if (val.ammount !=='' && val.ammount != undefined && val.ammount != null){
					formData.set('service[charges]['+i+'][charge_id]', val.charge_type_id)
					formData.set('service[charges]['+i+'][vehicle_id]', (val.vehicle_id) ? val.vehicle_id : '')
					formData.set('service[charges]['+i+'][value]', (val.ammount) ? val.ammount.replace('$','') : 's')
					formData.set('service[charges]['+i+'][cutoff_frequency]', val.cutoff_frequency)
					formData.set('service[charges]['+i+'][payment_deadline]', val.payment_deadline)
					i++;
				}
			}
		})
*/

    var self = this;
    const token = localStorage.getItem("userToken");
    if (this.state.service.id === "") {
      axios
        .post(api.service().post(this.state.contract_id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          let dialog = {
            errors: true,
            message: "Se cargaron los datos con éxito!",
            open: true
          };
          self.setState({ dialog: dialog });
        })
        .catch(function(error) {
          let dialog = {
            errors: true,
            message:
              "Hubo algun problema al cargarse los datos. Por favor volver a intentar",
            open: true
          };
          self.setState({ dialog: dialog });
        });
    } else {
      formData.append("service[id]", this.state.service.id);
      formData.append("_method", "patch");
      axios
        .post(api.service().patch(this.state.service.id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          let dialog = {
            errors: false,
            message: "Servicios contratados modificados con éxito!",
            open: true
          };
          self.setState({ dialog: dialog });
        })
        .catch(function(error) {
          var error_message = "";
          var errors = error.response.data;
          if (errors.errors) {
            if (errors.errors.status_code !== 404) {
              var keys = Object.keys(errors.errors);
              for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var key_errors = errors.errors[key];
                key_errors.map((val, idx) => {
                  error_message = error_message.concat(val).concat(" ");
                });
              }
            } else {
              error_message =
                "Ha ocurrido un error. Contacte a su administrador";
            }
          } else {
            error_message = "Ha ocurrido un error. Contacte a su administrador";
          }

          let dialog = {
            errors: true,
            message: error_message,
            open: true
          };
          self.setState({ dialog: dialog });
        });
    }
  };

  handleDialogClose = () => {
    var dialog = this.state.dialog;
    dialog.open = false;
    dialog.errors = [];
    var delete_dialog = this.state.delete_dialog;
    delete_dialog.open = false;
    delete_dialog.errors = [];
    this.setState({ dialog: dialog, delete_dialog: delete_dialog });
  };

  handleDialogAccept = () => {
    window.location.href = "/contracts";
  };

  handleDialogCancel = () => {
    this.handleDialogClose();
  };

  render() {
    const onChange = (currentNode, selectedNodes) => {
      console.log("onChange::", currentNode, selectedNodes);
    };
    const onAction = (node, action) => {
      console.log("onAction::", action, node);
    };
    const onNodeToggle = currentNode => {
      console.log("onNodeToggle::", currentNode);
    };

    const classes = this.props.classes;
    const service = this.state.service;
    const disabled = this.state.disabled;
    return (
      <React.Fragment>
        <Container
          fluid
          className="main-content-container px-4 position-relative"
        >
          {this.state.loading ? (
            <LinearProgress />
          ) : (
            <React.Fragment>
              <ConfirmDialog
                confirm_dialog={this.state.dialog.open}
                title={this.state.dialog.title}
                message={this.state.dialog.message}
                onClose={this.handleDialogClose}
                onAccept={
                  !this.state.dialog.errors
                    ? this.handleDialogAccept
                    : this.handleDialogClose
                }
                onCancel={this.handleDialogCancel}
                errors={this.state.dialog.errors}
              />
              <ConfirmDialog
                confirm_dialog={this.state.delete_dialog.open}
                title={this.state.delete_dialog.title}
                message={this.state.delete_dialog.message}
                onClose={this.handleDialogClose}
                onAccept={
                  this.state.delete_id !== ""
                    ? e => {
                        this.handleDeleteCharge(e, this.state.delete_id, true);
                      }
                    : this.handleDialogAccept
                }
                onCancel={this.handleDialogCancel}
                errors={this.state.delete_dialog.errors}
              />
              <Row class="mt-1" noGutters className="page-header">
                <div class="col-9">
                  <Typography variant="h6">Servicios contratados</Typography>
                </div>
                <div class="col-3">
                  {this.state.action === "view" ? (
                    <div style={{ textAlign: "right" }}>
                      <Fab
                        color="secondary"
                        aria-label="edit"
                        className="MuiButtonBase-root MuiFab-sizeSmall m-1"
                        onClick={this.handleEdit}
                      >
                        <EditIcon onClick={this.handleEdit} />
                      </Fab>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.action === "edit" ? (
                    <div style={{ textAlign: "right" }}>
                      <Fab
                        color="primary"
                        aria-label="edit"
                        className="MuiButtonBase-root MuiFab-sizeSmall m-1"
                        onClick={this.handleView}
                      >
                        <ViewIcon onClick={this.handleView} />
                      </Fab>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Row>
              <Row>
                <div className="row col-12 mb-2 mt-2 ml-2">
                  <TextField
                    id="name"
                    name="name"
                    margin="normal"
                    className="mr-2 mt-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    disabled={this.state.disabled}
                    onChange={this.handleChange}
                    value={service.name}
                    inputProps={{ style: { width: 250, fontSize: "0.75rem" } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Nombre</Typography>
                        </InputAdornment>
                      )
                    }}
                  />

                  <TextField
                    id="description"
                    name="description"
                    margin="normal"
                    fullWidth
                    className="mr-2 mt-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    disabled={this.state.disabled}
                    onChange={this.handleChange}
                    value={service.description}
                    inputProps={{ style: { fontSize: "0.75rem" } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Descripción</Typography>
                        </InputAdornment>
                      )
                    }}
                  />
                </div>
              </Row>
              <Row>
                <div class="col-12 ml-2">
                  <Typography
                    gutterBottom
                    variant="h6"
                    className="d-flex flex-row justify-content-between"
                  >
                    Cargos
                    <IconButton className="" disabled={disabled} size="small">
                      <AddIcon
                        disabled={disabled}
                        onClick={e => {
                          this.addNewCharge(e);
                        }}
                      />
                    </IconButton>
                  </Typography>
                </div>
                {this.state.service.charges.map((val, idx) => {
                  let methodTypes = originTypes.find(
                    option => option.value === val.source_type
                  );
                  if (methodTypes) {
                    methodTypes = methodTypes.methodTypes;
                  } else {
                    methodTypes = fullMethodTypes;
                  }
                  const showDropdown = val.id > 0;
                  let chargeOpen = true;
                  if (val.id > 0) {
                    chargeOpen = val.open ? val.open : false;
                  }
                  return (
                    <React.Fragment>
                      <div
                        className="col-12 ml-2 py-2"
                        style={{ borderTop: "1px solid #ccc" }}
                      >
                        {showDropdown && (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.handleToogleCharge(idx);
                            }}
                          >
                            <Typography
                              variant="caption"
                              style={{ fontSize: "0.85rem", fontWeight: "500" }}
                            >
                              {val.charge_type.name}
                            </Typography>
                            <ArrowDownwardIcon
                              style={{
                                transform: chargeOpen ? "rotate(180deg)" : ""
                              }}
                            />
                          </div>
                        )}
                        {!showDropdown && (
                          <Typography
                            variant="caption"
                            style={{ fontSize: "0.85rem", fontWeight: "500" }}
                          >
                            Nuevo cargo
                          </Typography>
                        )}
                        {chargeOpen && (
                          <>
                            <div class="col-12 ml-2">
                              <TextField
                                id={"charge_id." + idx}
                                name={"charge_id." + idx}
                                select
                                label="Cargo"
                                margin="normal"
                                disabled={disabled}
                                className={classes.select}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                onChange={this.handleChange}
                                value={
                                  val.id
                                    ? val.charge_type.id
                                    : val.charge_type_id
                                }
                                inputProps={{
                                  style: { minWidth: 100, fontSize: "0.75rem" }
                                }}
                                InputProps={{
                                  style: { minWidth: 100, fontSize: "0.75rem" }
                                }}
                              >
                                {this.state.charges.map(option => (
                                  <MenuItem
                                    key={option.id}
                                    value={option.id}
                                    className={classes.typography}
                                  >
                                    {option.name}
                                  </MenuItem>
                                ))}
                              </TextField>
                              {val.id > 0 && val.sales_task && (
                                <Tooltip
                                  title={
                                    "Item facturable: " + val.sales_task.name
                                  }
                                >
                                  <ViewIcon fontSize="small" />
                                </Tooltip>
                              )}

                              <TextField
                                id={"start_date." + idx}
                                name={"start_date." + idx}
                                label="Fecha inicio"
                                type="date"
                                margin="normal"
                                className="mr-2 mt-3"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{ style: { fontSize: "0.75rem" } }}
                                inputProps={{ style: { fontSize: "0.75rem" } }}
                                onChange={this.handleChange}
                                value={val.start_date}
                              />
                              <TextField
                                id={"end_date." + idx}
                                name={"end_date." + idx}
                                label="Fecha fin"
                                type="date"
                                margin="normal"
                                className="mr-2 mt-3"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{ style: { fontSize: "0.75rem" } }}
                                inputProps={{ style: { fontSize: "0.75rem" } }}
                                onChange={this.handleChange}
                                value={val.end_date}
                              />
                              <TextField
                                label="Valor"
                                onChange={this.handleChange}
                                type="number"
                                className="mr-2"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{
                                  style: { width: 100, fontSize: "0.75rem" }
                                }}
                                id={"value." + idx}
                                name={"value." + idx}
                                value={val.value}
                                margin="normal"
                              />

                              <TextField
                                label="Plazo"
                                onChange={this.handleChange}
                                select
                                className="mr-2"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{
                                  style: { width: 150, fontSize: "0.75rem" }
                                }}
                                id={"payment_deadline." + idx}
                                name={"payment_deadline." + idx}
                                value={val.payment_deadline}
                                margin="normal"
                              >
                                {paymentDeadlines.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option.value}
                                    style={{ fontSize: "0.75rem" }}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </TextField>
                              <TextField
                                label="Freq. corte"
                                select
                                onChange={this.handleChange}
                                className="mr-2"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{
                                  style: { width: 80, fontSize: "0.75rem" }
                                }}
                                id={"cutoff_frequency." + idx}
                                name={"cutoff_frequency." + idx}
                                margin="normal"
                                value={val.cutoff_frequency}
                              >
                                {cutoffFrequencies.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option.value}
                                    style={{ fontSize: "0.75rem" }}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </TextField>
                              {/*<TextField
                                label="Origen"
                                type="text"
                                onChange={this.handleChange}
                                className="mr-2"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{ style: { fontSize: "0.75rem" } }}
                                id={"source_type." + idx}
                                name={"source_type." + idx}
                                margin="normal"
                                value={val.source_type}
                                select
                              >
                                {originTypes.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option.value}
                                    className={classes.typography}
                                  >
                                    {option.name}
                                  </MenuItem>
                                ))}
                              </TextField>
                              {methodTypes.length > 0 && (
                                <TextField
                                  label="Metodo"
                                  onChange={this.handleChange}
                                  className="mr-2"
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                  disabled={disabled}
                                  InputProps={{
                                    style: { fontSize: "0.75rem" }
                                  }}
                                  id={"calc_method." + idx}
                                  name={"calc_method." + idx}
                                  margin="normal"
                                  value={val.calc_method}
                                  select
                                >
                                  {methodTypes.map((option, idx) => (
                                    <MenuItem
                                      key={idx}
                                      value={option}
                                      className={classes.typography}
                                    >
                                      {option}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                              <TextField
                                label="Tipo de valor"
                                onChange={this.handleChange}
                                className="mr-2"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{ style: { fontSize: "0.75rem" } }}
                                id={"value_type." + idx}
                                name={"value_type." + idx}
                                margin="normal"
                                value={val.value_type}
                                select
                              >
                                {chargeValueTypes.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option.value}
                                    className={classes.typography}
                                  >
                                    {option.name}
                                  </MenuItem>
                                ))}
                              </TextField>
                              <TextField
                                label="Prorateo"
                                onChange={this.handleChange}
                                className="mr-2"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{ style: { fontSize: "0.75rem" } }}
                                id={"proration_type." + idx}
                                name={"proration_type." + idx}
                                margin="normal"
                                value={val.proration_type}
                                select
                              >
                                {prorationTypes.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option.value}
                                    className={classes.typography}
                                  >
                                    {option.name}
                                  </MenuItem>
                                ))}
                              </TextField>
                              */}
                              <TextField
                                id={`purchase_order.${idx}`}
                                name={`purchase_order.${idx}`}
                                label="Orden de compra"
                                type="text"
                                margin="normal"
                                className="mr-2 mt-3"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{ style: { fontSize: "0.75rem" } }}
                                inputProps={{ style: { fontSize: "0.75rem" } }}
                                onChange={this.handleChange}
                                value={val.purchase_order}
                              />
                              <TextField
                                label="Vehículo generico"
                                onChange={this.handleChange}
                                className="mr-2"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{ style: { fontSize: "0.75rem" } }}
                                id={"default_vehicle_id." + idx}
                                name={"default_vehicle_id." + idx}
                                margin="normal"
                                value={val.proration_type}
                                select
                              >
                                {this.state.vehicles.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option.id}
                                    className={classes.typography}
                                  >
                                    {option.plate}
                                  </MenuItem>
                                ))}
                              </TextField>
                              <TextField
                                label="Usar toda la flota"
                                onChange={this.handleChange}
                                className="ml-2"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled={disabled}
                                InputProps={{ style: { fontSize: "0.75rem" } }}
                                id={"all_fleet." + idx}
                                name={"all_fleet." + idx}
                                margin="normal"
                                value={val.all_fleet}
                                select
                              >
                                <MenuItem value={1} style={{ fontSize: "0.75rem" }}>Si - Usar toda la flota</MenuItem>
                                <MenuItem value={0} style={{ fontSize: "0.75rem" }}>No - Definir lista de vehículos</MenuItem>
                              </TextField>                              
                              {val.id > 0 && val.all_fleet == 0 && (
                                <Button
                                  className="mt-3"
                                  disabled={disabled}
                                  variant="contained"
                                  color="primary"
                                  startIcon={<DriveEtaIcon />}
                                  onClick={e => {
                                    window.location.href =
                                      "/service-charge/" +
                                      val.id +
                                      "/vehicles";
                                  }}
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  Cargar vehículos
                                </Button>
                              )}

                              {/*<TextField
											id={"vehicle_id."+idx}
											name={"vehicle_id."+idx}
											select
											label="Patente"
											margin="normal"
											className={classes.select}
											InputLabelProps={{
												shrink: true
											}}
											onChange={this.handleChange}
											value={val.vehicle_id}
											inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
											InputProps={{
												style:{fontSize: '0.75rem'}
												}}
										>
											{this.state.vehicles.map((option) => (
											<MenuItem key={option.id} value={option.id} className={classes.typography}>
												{option.plate}
											</MenuItem>
											))}
										</TextField>*/}

                              {/*<IconButton className="mt-3" disabled={disabled} size="small">
											<AddIcon disabled={disabled} onClick={(e)=> {this.addNewCharge(e)}} />
										</IconButton>
										<IconButton  className="mt-3" disabled={disabled} size="small">
											<RemoveIcon disabled={disabled} onClick={(e) => {this.removeCharge(e,idx, (val.id !== undefined) ? false : true )}} />
										</IconButton>
									*/}
                            </div>
                          </>
                        )}
                      </div>
                    </React.Fragment>
                  );
                })}
              </Row>
              <Row>
                <div className="col-12 ml-2">
                  <div className="d-flex flex-row justify-content-between">
                    <Typography gutterBottom variant="h6">
                      Tipos de OT contratadas
                    </Typography>
                    <ArrowDownwardIcon
                      onClick={() => {
                        this.toogleWorkOrderList();
                      }}
                      style={{
                        cursor: "pointer",
                        transform: this.state.showWorkOrderList
                          ? "rotate(180deg)"
                          : ""
                      }}
                    />
                  </div>
                </div>
                {this.state.showWorkOrderList && (
                  <div>
                    {this.state.service.work_order_types.map((val, idx) => {
                      var description = val.description ? val.description : "";
                      return (
                        <React.Fragment>
                          <div class="col-12 ml-2">
                            {val.id > 0 ? (
                              <TextField
                                id={"work_order_type_id." + idx}
                                name={"work_order_type_id." + idx}
                                label="Tipo de OT"
                                margin="normal"
                                className={classes.select}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                disabled
                                onChange={this.handleChange}
                                value={val.work_order_type.name}
                                inputProps={{ style: { fontSize: "0.75rem" } }}
                                InputProps={{
                                  style: { fontSize: "0.75rem" }
                                }}
                              />
                            ) : (
                              <TextField
                                id={"work_order_type_id." + idx}
                                name={"work_order_type_id." + idx}
                                select
                                label="Tipo de OT"
                                margin="normal"
                                className={classes.select}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                onChange={this.handleChange}
                                value={val.work_order_type_id}
                                inputProps={{
                                  style: { minWidth: 70, fontSize: "0.75rem" }
                                }}
                                InputProps={{
                                  style: { fontSize: "0.75rem" }
                                }}
                              >
                                {this.state.work_order_types.map(option => (
                                  <MenuItem
                                    key={option.id}
                                    value={option.id}
                                    className={classes.typography}
                                  >
                                    {option.name}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                            <TextField
                              id={"work_order_state_id." + idx}
                              name={"work_order_state_id." + idx}
                              select
                              label="Incluido?"
                              margin="normal"
                              className={classes.select}
                              InputLabelProps={{
                                shrink: true
                              }}
                              onChange={this.handleChange}
                              value={
                                val.work_order_state_id
                                  ? val.work_order_state_id
                                  : ""
                              }
                              inputProps={{
                                style: { minWidth: 70, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                style: { fontSize: "0.75rem" }
                              }}
                            >
                              {this.state.task_states.map(option => (
                                <MenuItem
                                  key={option.task_state_id}
                                  value={option.task_state_id}
                                  className={classes.typography}
                                >
                                  {option.task_state_name}
                                </MenuItem>
                              ))}
                            </TextField>
                            <TextField
                              id={"budget_required." + idx}
                              name={"budget_required." + idx}
                              select
                              label="Requiere presupuesto?"
                              margin="normal"
                              className={classes.select}
                              InputLabelProps={{
                                shrink: true
                              }}
                              onChange={this.handleChange}
                              value={val.budget_required}
                              inputProps={{
                                style: { width: 100, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                style: { fontSize: "0.75rem", width: 100 }
                              }}
                            >
                              {this.state.budget_required_options.map(
                                option => (
                                  <MenuItem
                                    key={option.id}
                                    value={option.id}
                                    className={classes.typography}
                                  >
                                    {option.value}
                                  </MenuItem>
                                )
                              )}
                            </TextField>
                            <TextField
                              id={"validate_max_total_price." + idx}
                              name={"validate_max_total_price." + idx}
                              select
                              label="Validar monto presupuesto?"
                              margin="normal"
                              className={classes.select}
                              InputLabelProps={{
                                shrink: true
                              }}
                              onChange={this.handleChange}
                              value={val.validate_max_total_price}
                              inputProps={{
                                style: { width: 100, fontSize: "0.75rem" }
                              }}
                              InputProps={{
                                style: { fontSize: "0.75rem", width: 100 }
                              }}
                            >
                              {this.state.budget_required_options.map(
                                option => (
                                  <MenuItem
                                    key={option.id}
                                    value={option.id}
                                    className={classes.typography}
                                  >
                                    {option.value}
                                  </MenuItem>
                                )
                              )}
                            </TextField>
                            <NumberFormat
                              id={"max_total_price." + idx}
                              name={"max_total_price." + idx}
                              label="Monto"
                              value={val.max_total_price}
                              onChange={this.handleChange}
                              className="m-0 mt-3 mr-2 p-0"
                              InputProps={{
                                style: { minWidth: 70, fontSize: "0.75rem" }
                              }}
                              decimalSeparator="."
                              prefix={"$"}
                              customInput={TextField}
                              InputLabelProps={{
                                shrink: true
                              }}
                              isAllowed={values => {
                                let { floatValue } = values;
                                floatValue =
                                  floatValue !== undefined ? floatValue : 0;
                                return floatValue >= 0 && floatValue < 99999999;
                              }}
                            />
                            <TextField
                              label="Comentarios"
                              type="text"
                              onChange={this.handleChange}
                              className="mr-2 w-25"
                              InputLabelProps={{
                                shrink: true
                              }}
                              disabled={this.state.disabled}
                              value={description}
                              InputProps={{ style: { fontSize: "0.75rem" } }}
                              id={"work_order_description." + idx}
                              name={"work_order_description." + idx}
                              margin="normal"
                            />
                            <IconButton
                              className="mt-3"
                              disabled={disabled}
                              size="small"
                            >
                              <AddIcon
                                disabled={disabled}
                                onClick={e => {
                                  this.addNewWorkOrderType(e);
                                }}
                              />
                            </IconButton>
                            <IconButton
                              className="mt-3"
                              disabled={disabled}
                              size="small"
                            >
                              <RemoveIcon
                                disabled={disabled}
                                onClick={e => {
                                  this.removeWorkOrderType(idx);
                                }}
                              />
                            </IconButton>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}
              </Row>
              {/* <Row>
                <div class="col-12 ml-2">
                  <Typography gutterBottom variant="h6" className="">
                    Tareas contratadas
                  </Typography>
                </div>

                {this.state.service.tasks.map((val, idx) => {
                  return (
                    <React.Fragment>
                      <div class="col-12 ml-2">
                        {val.task_id === "" ? (
                          <DropdownTreeSelect
                            disabled={this.state.disabled}
                            data={this.state.tasks}
                            onChange={e => {
                              onChange(e);
                              this.setDropdownTask(`tasks-${idx}`, e);
                            }}
                            onAction={onAction}
                            onNodeToggle={onNodeToggle}
                            mode="radioSelect"
                            className="mt-4 my-2 center"
                            texts={{ placeholder: "Buscar tareas" }}
                            style={{ display: "inline-block" }}
                          />
                        ) : (
                          <TextField
                            label="Cargo"
                            disabled
                            id={`tasks-${idx}`}
                            InputLabelProps={{
                              shrink: true
                            }}
                            value={
                              val.id
                                ? val.task.task
                                  ? val.task.task.name
                                  : ""
                                : val.taskLabel
                            }
                            InputProps={{
                              style: {
                                width: "10rem",
                                fontSize: "0.75rem",
                                marginTop: "32px",
                                marginRight: "8px"
                              }
                            }}
                          />
                        )}
                        <TextField
                          id={"task_state_id." + idx}
                          name={"task_state_id." + idx}
                          select
                          label="Inluido?"
                          margin="normal"
                          className={classes.select}
                          InputLabelProps={{
                            shrink: true
                          }}
                          onChange={this.handleChange}
                          value={val.task_state_id ? val.task_state_id : ""}
                          inputProps={{
                            style: { minWidth: 70, fontSize: "0.75rem" }
                          }}
                          InputProps={{
                            style: { fontSize: "0.75rem" }
                          }}
                        >
                          {this.state.task_states.map(option => (
                            <MenuItem
                              key={option.task_state_id}
                              value={option.task_state_id}
                              className={classes.typography}
                            >
                              {option.task_state_name}
                            </MenuItem>
                          ))}
                        </TextField>

                        <TextField
                          label="Descripción en contrato"
                          type="text"
                          className="mr-2"
                          InputLabelProps={{
                            shrink: true
                          }}
                          disabled={this.state.disabled}
                          InputProps={{ style: { fontSize: "0.75rem" } }}
                          id={"contract_description." + idx}
                          onChange={this.handleChange}
                          name={"contract_description." + idx}
                          margin="normal"
                          value={val.contract_description}
                        />
                        <TextField
                          label="Comentarios"
                          type="text"
                          onChange={this.handleChange}
                          className="mr-2 w-50"
                          InputLabelProps={{
                            shrink: true
                          }}
                          disabled={this.state.disabled}
                          InputProps={{ style: { fontSize: "0.75rem" } }}
                          id={"description." + idx}
                          name={"description." + idx}
                          margin="normal"
                          value={val.description}
                        />
                        <IconButton
                          className="mt-3"
                          disabled={disabled}
                          size="small"
                        >
                          <AddIcon
                            disabled={disabled}
                            onClick={e => {
                              this.addNewTask(e);
                            }}
                          />
                        </IconButton>
                        <IconButton
                          className="mt-3"
                          disabled={disabled}
                          size="small"
                        >
                          <RemoveIcon
                            disabled={disabled}
                            onClick={e => {
                              this.removeTask(idx);
                            }}
                          />
                        </IconButton>
                      </div>
                    </React.Fragment>
                  );
                })}
              </Row>*/}
              <Row className="ml-1">
                {this.state.action !== "view" ? (
                  <div>
                    <Button
                      type="submit"
                      variant="contained"
                      className="mt-3 ml-1 mr-1"
                      color="primary"
                      onClick={this.handleSubmit}
                    >
                      Guardar
                    </Button>
                    <Button
                      variant="outlined"
                      className="mt-3 ml-1 mr-1"
                      color="secondary"
                      onClick={() => {
                        window.location.href =
                          "/client-invoicing-configs/" + this.state.client_id;
                      }}
                    >
                      Configurar facturación
                    </Button>
                    <Button
                      variant="contained"
                      className="mt-3 ml-1 mr-1"
                      color="secondary"
                      href={"/contracts"}
                    >
                      Cancelar
                    </Button>
                  </div>
                ) : (
                  <div>
                    <Button
                      variant="contained"
                      className="mt-3 ml-1 mr-1"
                      color="secondary"
                      href={"/contracts"}
                    >
                      Volver
                    </Button>
                  </div>
                )}
              </Row>
            </React.Fragment>
          )}
        </Container>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(Service);
